import axiosInstance from './axiosInstance'; 

const API_URL = 'https://idealonline.com.tr/service/idealonline/v1/';

export const getEmailDomainSearch = async (email,status) => {
    try {
      const response = await axiosInstance.get(`instutionscustomers/EmailDomainSearch/${email}/${status}`, {
     
      });
      return response.data;
    } catch (error) {
      console.error('Kurumsal müşteri listesi getirilirken hata oluştu:', error);
      throw error;
    }
  };

export const getInstCustomerIpCheck = async (id,status) => {
    try {
      const response = await axiosInstance.get(`instutionscustomers/InstCustomerIpCheck/${id}/${status}`, {
     
      });
      return response.data;
    } catch (error) {
      console.error('Kurumsal müşteri listesi getirilirken hata oluştu:', error);
      throw error;
    }
  };

export const getCustomerInstitutionByIp = async () => {
  try{
    const response = await axiosInstance.get(`instutionscustomers/instutionscustomersDetailByIp`, {
     
      });
    return response.data;
  } catch (error) {
    console.error('Kurum Bilgisi IPden alınamadı', error);
    throw error;
  }
};

export const getCustomerInstitutionByToken = async (token) => {
  try {
    const response = await axiosInstance.get(`instutionscustomers/userInstution`, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
    return response.data;
  } catch (error) {
    // Hata mesajını logla
    console.error('Kurum Bilgisi User Tokendan alınamadı', error.response ? error.response.data : error);
    throw error;
  }
};

export const getInstitutionCustomersList = async () => {
  try {
    const response = await axiosInstance.get(`instutionscustomers/search/InstutionscustomersList/1`);
    return response.data;
  } catch (error) {
    console.error('Kurum müşteri listesi (status 1) alınamadı:', error);
    throw error;
  }
};

  